import { RouteComponentProps } from '@reach/router'
import React, { memo } from 'react'

export const NotFound = memo(function NotFound (params: RouteComponentProps) {
  return <div>404</div>
})
